@if (data$ | async; as data) {
<div class="news-page-wrapper">
  <div class="viewAll">
    <a [routerLink]="'/news'">
      <i class="material-icons">keyboard_arrow_left</i> {{ 'newsArticles.backToNews' | cxTranslate }}
    </a>
  </div>
  <div class="article-wrapper">
    @if (data?.image) {
    <div class="article-image">
      <cx-media [container]="data.image" removeImageTitleAttr></cx-media>
    </div>
    }
    <div class="article-details">
      <div class="article-category">
        @if (category$ | async; as category) {
        {{ category.name }}
        }
      </div>
      <div class="article-title">{{ data.title }}</div>
      <div class="article-content" [innerHTML]="data.content | safeHtml"></div>
    </div>
  </div>
</div>
}
